import { z } from 'zod';

import { isIsoDate, isWeekStart } from '../../weekly';

export const IsoDateSchema = z.string().refine(isIsoDate, 'Invalid date, expected YYYY-MM-DD');
export const WeekStartSchema = IsoDateSchema.refine(isWeekStart, 'weekStart must be a Monday');

export const PlanningBoardWeeklyQuerySchema = z.object({
  weekStart: WeekStartSchema,
});

export type PlanningBoardWeeklyQuery = z.infer<typeof PlanningBoardWeeklyQuerySchema>;

export const WeeklyTrailerSchema = z.object({
  id: z.number(),
  name: z.string(),
  licensePlate: z.string(),
});

export type WeeklyTrailer = z.infer<typeof WeeklyTrailerSchema>;

export const WeeklyTripStatusSchema = z.enum(['Ok', 'InTransit', 'Risk', 'MajorIssue']);

export type WeeklyTripStatus = z.infer<typeof WeeklyTripStatusSchema>;

export const WeeklyTripSchema = z.object({
  id: z.string(),
  date: z.string(),
  sequence: z.number(),
  loading: z.string(),
  loadingStatus: WeeklyTripStatusSchema.nullable(),
  unloading: z.string(),
  unloadingStatus: WeeklyTripStatusSchema.nullable(),
  km: z.number(),
});

export type WeeklyTrip = z.infer<typeof WeeklyTripSchema>;

/** The trailer a truck pulls on a day, set apart from its trips. */
export const WeeklyDayTrailerSchema = z.object({
  date: z.string(),
  trailer: WeeklyTrailerSchema,
});

export type WeeklyDayTrailer = z.infer<typeof WeeklyDayTrailerSchema>;

const PlannerSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const WeeklyTruckSchema = z.object({
  id: z.string(),
  licensePlate: z.string(),
  supplierName: z.string(),
  planner: PlannerSchema.nullable(),
  /** This week's target, or the most recent earlier one when none was set for this week. */
  targetKm: z.number().nullable(),
  trips: z.array(WeeklyTripSchema),
  /** Only the days with a trailer, sorted by date. */
  trailers: z.array(WeeklyDayTrailerSchema),
});

export type WeeklyTruck = z.infer<typeof WeeklyTruckSchema>;

export const PlanningBoardWeeklyResponseSchema = z.object({
  weekStart: z.string(),
  days: z.array(z.string()),
  planners: z.array(PlannerSchema),
  trucks: z.array(WeeklyTruckSchema),
});

export type PlanningBoardWeeklyResponse = z.infer<typeof PlanningBoardWeeklyResponseSchema>;
